import wordmark from '../assets/wordmark-vip.png';

/**
 * Het hoofdlogo: VIP in het facetlijnwerk van de huisstijl, op de plek waar
 * eerder het Veerenstael-woordmerk stond.
 *
 * De standaardhoogte is 32 en niet 28. Dit merk is hairline lijnwerk met zes
 * parallelle lijnen over de breedte van een letter, en daaronder vallen de
 * facetten weg tot een grijze waas. Het Veerenstael-woordmerk kon wel klein,
 * want dat zijn dichte letters.
 */
export function Logo({ height = 32 }: { height?: number }) {
  return (
    <img
      alt="VIP"
      height={height}
      src={wordmark}
      style={{ display: 'block', height, width: 'auto' }}
    />
  );
}
